export const styled = {
  tagIntro: {
    color: "black",
    textAlign: "center",
    margin: "30px 0",
    fontWeight: "bold",
  },
  root: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  errorMessage: {
    color: "#dc3456",
    fontWeight: "600",
  },
  deTaild: {
    textDecoration: 'none',
    color: 'white',
    "&:hover": {
      textDecoration: 'none',
      color: 'white',
    }
  }
};
